import React from 'react'
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import CommunicationForm from "./CommunicationComponents/CommunicationForm";

import { useAddCommunicationMutation } from "store/services/communicationApi";

import { useAppMeta } from "hooks";

const CommunicationCreateScreen = () => {

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Communication", path: "/app/crm/communication/list" },
    { title: "New Communication" }];

  const [createCommunication, { isLoading: creatingCommunication }] =
    useAddCommunicationMutation();

  // methods
  const handleAddCommunication = async (data) => {

    try {
      const { _id } = await createCommunication(data).unwrap();
      toast.success("Communication Created !");
      navigate(`/app/crm/communication/${_id}/detail`)
    } catch (error) {
      toast.error(
        error?.data?.message ?? error.message ?? "Could Not Created Communication !"
      );
    }
  }
  useAppMeta("New Communication");
  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingCommunication}>
      <BreadcrumbLayout.Paper>
        <CommunicationForm isBusy={creatingCommunication} onSubmit={handleAddCommunication} />
      </BreadcrumbLayout.Paper>

    </BreadcrumbLayout>
  )
}

export default CommunicationCreateScreen